import React from 'react';
import { LinkButton, Typography } from 'fronton-react';
import { ctaBlockStyles } from './styles';
import { GAClickButton } from 'utils';

export const CTABlock = () => {
	const scrollToForm = () => {
		GAClickButton({
			elementName: 'startContent',
			elementBlock: 'landingChernovoyRemont',
			elementText: 'Записаться на консультацию',
		});
		document.getElementById('applicationForm').scrollIntoView({
			behavior: 'smooth',
		});
	};
	return (
		<div className={ctaBlockStyles}>
			<div className="cta-text">
				<div className="img-container">
					<img src="https://cdn.lemanapro.ru/lmru/image/upload/v1724323325/fudzi/elbrus/images/landings/rough-work/NotePencil.png/NotePencil.png" />
				</div>
				<Typography variant="m" size="body_short">
					Запишитесь на бесплатную консультацию
				</Typography>
			</div>
			<LinkButton className="cta-btn" size="m" variant="accent" onClick={scrollToForm}>
				Записаться на консультацию
			</LinkButton>
		</div>
	);
};
